export const API_ERROR = "API_LOYALTY_ERROR";
export const LOYALTY_OPT_IN_API_ERROR = "LOYALTY_OPT_IN_API_ERROR";
export const GET_LOYALTY_DATA = "GET_LOYALTY_DATA";
export const SET_LOYALTY_DATA = "SET_LOYALTY_DATA";
export const OPTING_CUSTOMER_IN = "OPTING_CUSTOMER_IN";
export const TOGGLE_IS_FIRST_VIEW = "TOGGLE_IS_FIRST_VIEW";
export const TRACK_LOYALTY_BUTTON_CLICK = "TRACK_LOYALTY_BUTTON_CLICK";
